var Model = require('../Model');

var CertifiedInstrument = Object.create(Model);

CertifiedInstrument.name = 'CertifiedInstrument';
CertifiedInstrument['@class'] = 'CertifiedInstrument';
CertifiedInstrument.url = 'certifiedinstrument';
CertifiedInstrument.fields = {
  name: {
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 120, default: ''},
    }
  },
  model: {
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 120, default: ''},
    }
  },
  description: {
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 120, default: ''},
    }
  },
  serialNumber: {
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 120, default: ''},
    }
  },
  calibratedOn: {
    type: 'text',
    default: 'Pending',
    hidden: true,
    validators: {
      // presence: true, 
      // length: {minimum: 1, maximum: 32, default: ''},
    }
  },
  calibrationDue: {
    type: 'text',
    default: 'Pending',
    hidden: true,
    validators: {
      // presence: true, 
      // length: {minimum: 1, maximum: 32, default: ''},
    }
  },
  uncertainty: {
    type: 'number',
    default: 0.05,
    hidden: true,
    validators: {
      // presence: true, 
      // length: {minimum: 1, maximum: 32, default: ''},
    }
  },
  createdOn: {
    type: 'text',
    default: '',
    hidden: true
  },
  createdBy: {
    type: 'text',
    default: '',
    hidden: true
  },
  owner: {
    validators: {
      presence: true
    }
  },
  usedBy: {
    
  }
};

module.exports = CertifiedInstrument;